import { Component } from '@angular/core';
import { UserInfos } from 'src/app/_models/user.infos';
import { AuthenticationService } from 'src/app/_services/local/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {

  public user: UserInfos;

  constructor(private auth: AuthenticationService) {
    this.user = this.auth.getUserInfos();
  }

  checkLogIn(): boolean {
    return this.user.success;
  }

}
